export const isVideoWork = (work: any) => String(work?.type || '').toLowerCase() === 'video';

export const getPhotographyVideoUrl = (work: any): string => {
    const video = work?.video;
    const source = typeof video === 'string' ? video : video?.url || video?.videoUrl || video?.ossVideoUrl;
    return source || work?.videoUrl || work?.video_url || work?.ossVideoUrl || work?.oss_video_url || '';
};

export const getVideoAiText = (status: number | string) => {
    switch (Number(status)) {
        case 1: return '内容含AI生成元素';
        case 2: return '作者声明：内容含AI生成元素';
        case 3: return '内容疑似使用AI生成技术，请谨慎甄别';
        default: return '';
    }
};

export const isOwnPhotographyWork = (work: any, user: any) => (
    !!user?.code && !!work?.user?.code && String(user.code) === String(work.user.code)
);

export const canDeletePhotographyWork = (work: any, user: any, contestStatus: any) => (
    isOwnPhotographyWork(work, user) && (Number(contestStatus) !== 2 || Number(work?.status) !== 1)
);
